import { CheckCircle2 } from "lucide-react";
import PalommaLogo from "../PalommaLogo";

type SuccessDisplayProps = {
  companyName: string;
};

const SuccessDisplay = ({ companyName }: SuccessDisplayProps): JSX.Element => {
  return (
    <div className="flex min-h-screen items-center justify-center px-4 py-8">
      <div className="flex w-full max-w-[30rem] flex-col gap-6">
        <div className="mb-2 flex justify-center">
          <PalommaLogo height={75} width={75} />
        </div>

        <div className="w-full rounded-2xl bg-white p-10 shadow-xl">
          <div className="flex flex-col gap-6">
            <div className="mb-2 flex justify-center">
              <div className="rounded-full bg-purple-50 p-4">
                <CheckCircle2 className="size-12 text-purple-600" />
              </div>
            </div>

            <div className="mb-2 text-center">
              <h2 className="mb-3 text-2xl font-bold">
                ¡Organización Creada!
              </h2>
              <p className="text-gray-600">
                La organización <strong>{companyName}</strong> ha sido creada exitosamente.
              </p>
            </div>

            <div className="rounded-lg border border-purple-200 bg-purple-50 p-6 text-center">
              <p className="text-gray-700">
                Serás redirigido al inicio de sesión en breve...
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuccessDisplay;
